import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect, useRef, useState } from 'react';
import useValueRef from '../useValueRef';
type MutationFilter = (mutation: MutationRecord) => boolean;
function useMutationObserver(ref, filter, options) {
  const $ = _c(5);
  const observerRef = useRef(null);
  const filterRef = useValueRef(filter ?? null);
  const optionsRef = useValueRef(options);
  const [observed, setObserved] = useState(null);
  let t0;
  let t1;
  if ($[0] !== filterRef || $[1] !== optionsRef || $[2] !== ref) {
    t0 = () => {
      observerRef.current = new MutationObserver(muts => {
        for (const mut of muts) {
          const passes = typeof filterRef.current !== "function" || filterRef.current(mut);
          if (!passes) {
            continue;
          }
          setObserved(mut);
        }
      });
      observerRef.current.observe(ref.current, optionsRef.current);
      return () => {
        observerRef.current?.disconnect();
      };
    };
    t1 = [filterRef, optionsRef, ref];
    $[0] = filterRef;
    $[1] = optionsRef;
    $[2] = ref;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  return observed;
}
export default useMutationObserver;